// extracted by mini-css-extract-plugin
export default {"tier-1":"tier_tier-1__CVfLI","tier-2":"tier_tier-2__Xjl6o","tier-3":"tier_tier-3__H2L8J","tier-4":"tier_tier-4__6-pJS"};